'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' });

var Toc = function Toc(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Toc = (0, _pure2.default)(Toc);
Toc.muiName = 'SvgIcon';

exports.default = Toc;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Toc.js
// module id = 2946
// module chunks = 0